import type { ReactElement } from 'react'
import { useIntl } from 'react-intl'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_DISCOUNTED_INSURANCE_HASH,
} from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
  benefitLabel: ReactElement
  discountPercent: number
}

function LandingPageLoyaltyDiscountedInsurance(props: Props) {
  const { layout, benefitLabel, discountPercent } = props
  const intl = useIntl()

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="discounted_insurance"
    heading={intl.formatMessage(
      {
        defaultMessage: '{discountPercent}% off Travel & Cancellation Protection',
        id: 'R_zby_zxExifRXeLLAdT',
        description: 'Heading for loyalty discounted insurance benefit tile showing percentage discount',
      },
      { discountPercent },
    )}
    subtitle={benefitLabel}
    to={getLoyaltyBenefitModalPath(LOYALTY_DISCOUNTED_INSURANCE_HASH)}
  />
}

export default LandingPageLoyaltyDiscountedInsurance
